import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";
import { queryKeys } from "@/queryKeys";

export interface AnalyticsMetrics {
  total_decisions: number;
  approved_count: number;
  declined_count: number;
  approval_percentage: number;
  decline_percentage: number;
  total_volume_30d: number;
  avg_deal_size: number;
  avg_decision_time: number;
  top_decline_reasons: Array<{ reason: string; count: number }>;
  period_days: number;
}

export function useDecisionsAnalyticsQuery(days: number) {
  return useQuery({
    queryKey: queryKeys.decisionsAnalytics(days),
    queryFn: async (): Promise<AnalyticsMetrics> => {
      const response = await api.get<AnalyticsMetrics>(
        `/underwriting/decisions/analytics/?days=${days}`
      );
      return response.data;
    },
  });
}
